import type React from 'react';

import type { IconProps } from '../types';

export const InfoS: React.FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM12.75 11V16.25H14C14.4142 16.25 14.75 16.5858 14.75 17C14.75 17.4142 14.4142 17.75 14 17.75H10C9.58579 17.75 9.25 17.4142 9.25 17C9.25 16.5858 9.58579 16.25 10 16.25H11.25V11.75H10C9.58579 11.75 9.25 11.4142 9.25 11C9.25 10.5858 9.58579 10.25 10 10.25H12C12.4141 10.25 12.75 10.5756 12.75 11ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V8C12.75 8.41421 12.4142 8.75 12 8.75C11.5858 8.75 11.25 8.41421 11.25 8V7C11.25 6.58579 11.5858 6.25 12 6.25Z"
      fill={color}
    />
  </svg>
);
